import React from 'react';
import styled from 'styled-components';

type PaginationProps = {
  page: number; // 1-based
  totalPages: number;
  onPageChange: (page: number) => void;
};

export const Pagination: React.FC<PaginationProps> = ({
  page,
  totalPages,
  onPageChange,
}) => {
  return (
    <PaginationFooter>
      <PaginationButton
        onClick={() => onPageChange(Math.max(1, page - 1))}
        disabled={page <= 1}
        aria-label="Previous page"
      >
        <ChevronLeftIcon />
      </PaginationButton>
      <PageInfo>
        Page {page} of {totalPages}
      </PageInfo>
      <PaginationButton
        onClick={() => onPageChange(Math.min(totalPages, page + 1))}
        disabled={page >= totalPages}
        aria-label="Next page"
      >
        <ChevronRightIcon />
      </PaginationButton>
    </PaginationFooter>
  );
};

const PaginationFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-sm);
  padding: var(--spacing-md) 0;
`;

const PageInfo = styled.span`
  font-size: var(--text-xs);
  font-weight: var(--font-weight-normal);
  color: var(--text-muted);
  line-height: 18px;
  white-space: nowrap;
`;

const PaginationButton = styled.button`
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--background);
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color var(--transition-fast);

  &:hover:not(:disabled) {
    background: var(--surface-elevated);
  }

  &:disabled {
    opacity: 0.3;
    cursor: default;
  }

  color: var(--text-secondary);
`;

const ChevronLeftIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.5 3.5L5 7L8.5 10.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ChevronRightIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.5 3.5L9 7L5.5 10.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
